module.exports = __webpack_public_path__ + "358e2de8.svg";